import { StyleSheet } from 'aphrodite';
import { Controller } from '../common/Controller';

export const AppTheme = {
  primaryColor: '#353535',
  secondaryColor: '#F04452',
  tertiaryColor: '#B58250',
  primaryBg: '#E9ECF4',
  secondaryBg: '#F4F3F2',
  tertiaryBg: '#FFFFFF',
  textColor: '#4E4E4E',
  textColorVariant: '#9AA3B8',
  pagePadding: 5,
  viewPort: 1200,
  toolbarHeight: 80,
  selectedColor: '#71C9AF',
  pMargin: 0,
  borderColor: '#C1C1C1',
  mainTitleSize: 30,
  subTitleSize: 20,
  subTitleSizeBelow767: 18,
  fontSize: 22,
  dialogTitleFontSize: 30,
  dialogTitleFontSizeBelow767: 22,
  dialogContentFontSize: 18,
  dialogContentFontSizeBelow767: 15,
}


export const AppStyles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  containerNarrow: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    // alignContent: 'center',
    // alignItems: 'center',
    backgroundColor: AppTheme.primaryBg,
    maxWidth: 1200,
    minHeight: '100vh',
    '@media (max-width: 767px)': {
      margin: '0px 12px'
    },
    '@media(min-width: 768px) and (max-width: 1023px)': {
      margin: '0px 12px'
    },
  },
  containerContentCenter: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    maxWidth: 1200,
    minHeight: '100vh',
    '@media (max-width: 767px)': {
      margin: '0px 12px'
    },
    '@media(min-width: 768px) and (max-width: 1023px)': {
      margin: '0px 12px'
    },
  },
  entityTableLinkIcon: {
    padding: 3,
    fontSize: 28,
    color: 'black',
    cursor: 'pointer'
  },
  pageTitle: {
    fontSize: 32,
    paddingBottom: 24
  },
  pageSubTitle: {
    fontSize: 16,
    paddingBottom: 5
  }
});



// WEBPACK FOOTER //
// ./src/styles/AppTheme.js